import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { v4 as uuid } from 'uuid';
import { ViewQrCodeModalService } from '../../../../../../core/components/view-qr-code-modal/view-qr-code-modal.service';
import { CustomMessagesService } from '../../../../../../core/errors/custom-messages.service';

@Component({
  selector: 'tab-general',
  templateUrl: './tab-general.component.html',
  styleUrls: ['./tab-general.component.scss'],
})
export class TabGeneralComponent {

  @Input()
  public readonly locationEnvironmentForm: FormGroup;

  @Input()
  public readonly isViewMode: boolean;

  constructor(
    private readonly messageService: CustomMessagesService,
    private readonly viewQrCodeModalService: ViewQrCodeModalService
  ) {}

  public async generateQrCode(): Promise<void> {
    this.locationEnvironmentForm.get('qrCode').setValue(uuid());
    this.openQrCodeDialog();
    this.messageService.success('LOCATION_ENVIRONMENT_DIALOG.MESSAGE.QR_CODE');
  }

  public openQrCodeDialog(): void {
    const { qrCode, name } = this.locationEnvironmentForm.value;
    this.viewQrCodeModalService.open({
      qrCode: qrCode,
      fileName: name
    });
  }
}
